import React from "react";
import AccountStatementPage from "../components/AccountStatementPage";

// GP Loan Account Statement. The layout, calculation and PDF are shared with
// the Business Loan statement (components/AccountStatementPage.js).
const GplAccountStatement = () => (
  <AccountStatementPage title="GPL Account Statement Report" endpoint="getgplaccountstatement" product="GPL" />
);

export default GplAccountStatement;
